import { render, staticRenderFns } from "./graficoDistinta.vue?vue&type=template&id=1b6fee90"
import script from "./graficoDistinta.vue?vue&type=script&lang=js"
export * from "./graficoDistinta.vue?vue&type=script&lang=js"
import style0 from "./graficoDistinta.vue?vue&type=style&index=0&id=1b6fee90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports